import { render, staticRenderFns } from "./brandInfoComponent.vue?vue&type=template&id=07132272"
import script from "./brandInfoComponent.vue?vue&type=script&lang=js"
export * from "./brandInfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports